import React from "react";
import * as FaIcons from 'react-icons/fa';
import * as FiIcons from 'react-icons/fi';
import * as MdIcons from 'react-icons/md';

export const SidebarData = [
    {
        title: 'menu_dashboard',
        i18nKey: 'nav.dashboard',
        label: 'Dashboard',
        path: '/owner/dashboard',
        icon: <FaIcons.FaHome />,
        perm: 'orders' // most roles can see the dashboard (orders perm is widest shared staff perm)
    },
    {
        title: 'menu_pos',
        i18nKey: 'nav.pos',
        label: 'Point of Sale',
        path: '/owner/pos-dashboard',
        icon: <FaIcons.FaShoppingBag />,
        feature: 'pos', // plan-gated: locked for Starter (see PlanContext / UpgradePrompt)
        perm: 'pos'
    },
    {
        title: 'menu_management',
        i18nKey: 'nav.menu_management',
        label: 'Menu',
        path: '/owner/menu-management',
        icon: <FaIcons.FaPencilRuler />,
        perm: 'menu'
    },
    {
        title: 'modifier_groups',
        i18nKey: 'nav.modifier_groups',
        label: 'Modifiers',
        path: '/owner/modifier-groups',
        icon: <FaIcons.FaLayerGroup />,
        perm: 'modifiers'
    },
    {
        title: 'menu_reports',
        i18nKey: 'nav.reports',
        label: 'Reports',
        path: '/owner/reports',
        icon: <FaIcons.FaFileInvoice />,
        feature: 'analytics', // plan-gated: locked for Starter (see PlanContext / UpgradePrompt)
        perm: 'reports'
    },
    {
        title: 'menu_orders',
        i18nKey: 'nav.orders',
        label: 'Orders',
        path: '/owner/orders',
        icon: <FiIcons.FiRepeat />,
        perm: 'orders'
    },
    {
        title: 'menu_clients',
        i18nKey: 'nav.clients',
        label: 'Customers',
        path: '/owner/clients',
        icon: <FiIcons.FiUser />,
        perm: 'customers'
    },
    {
        title: 'menu_regulars',
        i18nKey: 'nav.regulars',
        label: 'Regulars',
        path: '/owner/regulars',
        icon: <FiIcons.FiUserPlus />,
        perm: 'customers'
    },
    {
        title: 'menu_loyalty',
        i18nKey: 'nav.loyalty',
        label: 'Loyalty',
        path: '/owner/loyalty',
        icon: <FiIcons.FiGift />,
        perm: 'customers'
    },
    // Reviews / Coupons / Rewards / Translations nav items are HIDDEN until the features are real
    // (they were Coming-Soon stubs — empty shelves hurt credibility with evaluators). See ROADMAP
    // "Trust fixes". Re-add the four item objects here (git history has them) when each ships.
    {
        title: 'menu_floor',
        i18nKey: 'nav.floor',
        label: 'Floor',
        path: '/owner/floor',
        icon: <FaIcons.FaThLarge />,
        perm: 'tables'
    },
    {
        title: 'menu_billing',
        i18nKey: 'nav.billing',
        label: 'Billing & Plan',
        path: '/owner/billing',
        icon: <MdIcons.MdOutlinePayments />,
        perm: 'billing'
    },
    {
        title: 'menu_settings',
        i18nKey: 'nav.settings',
        label: 'Settings',
        path: '/owner/settings',
        icon: <FiIcons.FiSettings />,
        perm: 'settings'
    },
];
